import { NgClass } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

@Component({
  selector: 'menu-item',
  imports: [NgClass],
  template: `
    <button
      type="button"
      class="group flex w-full items-center gap-3 rounded-2xl px-4 py-3 text-sm font-semibold transition-all"
      [ngClass]="{
        'bg-slate-900 text-white shadow-lg shadow-slate-900/20': isSelected(),
        'text-slate-500 hover:bg-slate-100 hover:text-slate-900': !isSelected()
      }"
      [attr.aria-current]="isSelected() ? 'page' : null"
      (click)="navigate()"
    >
      <span
        class="inline-flex h-9 w-9 items-center justify-center rounded-xl text-lg transition"
        [ngClass]="{
          'bg-white/10 text-white': isSelected(),
          'bg-sky-100 text-sky-600 group-hover:bg-sky-200 group-hover:text-sky-700': !isSelected()
        }"
      >
        <i class="text-base" [ngClass]="icon()"></i>
      </span>
      <span class="whitespace-nowrap">{{ title() }}</span>
    </button>
  `,
  styles: ``,
})
export class MenuItemComponent {
  icon = input.required<string>();
  title = input.required<string>();
  selected = input<boolean | null>();
  private router = inject(Router);
  protected updateNotification = toSignal(this.router.events);

  link = input.required<string>();

  isSelected = computed(() => {
    this.updateNotification();

    if (this.selected() !== null && this.selected() !== undefined) {
      return this.selected()!;
    }

    const currentRoute = this.router.url;
    const link = this.link();
    const pathSegments = currentRoute.split('/').filter(Boolean);

    return pathSegments.includes(link);
  });

  navigate() {
    return this.router.navigate(['account', this.link()]);
  }
}
